export enum OrderScheduleIcons {
  Refunded = 'Refunded',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  NextDue = 'NextDue',
  Overdue = 'Overdue',
  Owed = 'Owed',
}
